import React from "react";

import IconButton_ from "root/entities/Buttons/IconButtons";

// DEPRECATED
// --------------------------------------------------------------
const _IconButton_ = props => <IconButton_ {...props} />;

export default _IconButton_;
